import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import SaudiReqMain from "./SaudiReqMain";
const SaudiReq = () => {
  return (
    <div className="uaeReqContainer">
      <SaudiReqMain />
    </div>
  );
};

export default SaudiReq;
